<template>
  <a-row :gutter="[16, 16]">
    <a-col :span="24">
      <a-card size="small" type="inner" title="Filter Transaction Summary">
        <a-form layout="inline" :form="form" @submit="handleSubmit">
          <a-row :gutter="24">

            <a-col :xs="24" :sm="24" :md="12" :lg="8">
              <a-range-picker :ranges="dateRanges" format="YYYY-MM-DD" v-model="filteredRanges"
                              style="width: 100%"/>
            </a-col>
          </a-row>
          <a-row style="padding-top: 8px">
            <a-col :span="24" class="text-right">
              <a-button type="primary" html-type="submit" icon="filter">Filter
              </a-button>
              <a-button class="ml-2" type="dashed" html-type="reset" icon="reload" @click="handleReset">Reset
              </a-button>
              <a-button class="ml-2" type="dashed" shape="circle" icon="cloud-download" @click="handleDownload"/>
            </a-col>
          </a-row>
        </a-form>
      </a-card>
    </a-col>

    <a-col :span="24">
      <a-card>
        <h3>Summary for
          <strong v-if="filters.date.length > 0">
            {{ moment(filters.date[0], 'YYYY-MM-DD').format('DD MMMM YYYY') }} - {{ moment(filters.date[1], 'YYYY-MM-DD').format('DD MMMM YYYY') }}
          </strong>
          <strong v-else>{{ moment().format("MMMM YYYY") }}</strong>
        </h3>
      </a-card>
    </a-col>
    <a-skeleton :loading="loading" active>
      <a-col :xs="24" :md="12">
        <a-card>
          <a-statistic
            title="Client's Charge Amount"
            :value="items.client_price"
            prefix="Rp"
            :value-style="{ color: '#4b4dc1' }"
            style="margin-right: 50px">
            <template #prefix>
              <a-icon type="arrow-up" />
            </template>
          </a-statistic>
        </a-card>
      </a-col>
      <a-col :xs="24" :md="12">
        <a-card>
          <a-statistic
            title="Biller's Charge Amount"
            :value="items.biller_price"
            prefix="Rp"
            :value-style="{ color: '#ba8c4e' }"
            style="margin-right: 50px">
            <template #prefix>
              <a-icon type="arrow-up" />
            </template>
          </a-statistic>
        </a-card>
      </a-col>
      <a-col :xs="24" :md="12">
        <a-card>
          <a-statistic
            title="Count"
            :value="items.count"
            :value-style="{ color: '#3468c2' }"
            style="margin-right: 50px">
            <template #suffix>
              <a-icon type="arrow-up" />
            </template>
          </a-statistic>
        </a-card>
      </a-col>
      <a-col :xs="24" :md="12">
        <a-card>
          <a-statistic
            title="Profit"
            :value="items.profit"
            prefix="Rp"
            :value-style="{ color: '#3f8600' }"
            style="margin-right: 50px">
            <template #suffix>
              <a-icon type="stock" />
            </template>
          </a-statistic>
        </a-card>
      </a-col>
    </a-skeleton>
  </a-row>
</template>

<script>
export default {
  name: "transaction-summary",
  computed: {
    filteredRanges: {
      get() {
        return this.filters.date.map((o) => this.moment(o, 'YYYY-MM-DD'))
      },
      set(val) {
        this.filters.date = val.map((moment) => moment.format('YYYY-MM-DD'))
      }
    },
    exportUri() {
      let params = _.merge(this.filters, {
        timestamp: (new Date).getTime()
      })

      return this.routeUri('hyperion.transaction.summary.export') + '?' + this.$qs.stringify(params)
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      items: {
        count: 0,
        client_price: 0,
        biller_price: 0,
        profit: 0,
        month: 0
      },
      loading: false,
      expand: false,
      filters: {
        date: [],
      }
    }
  },
  created() {
    this.filters = _.merge(this.filters, this.$hyperion.request)
    this.getItems()
  },
  methods: {
    handleReset(e) {
      e.preventDefault()
      this.filters = {
        date: []
      }
    },
    handleSubmit(e) {
      e.preventDefault()
      this.pushState(this.filters)
      this.getItems()
    },
    handleDownload() {
      window.open(this.exportUri, '_blank')
    },
    getItems() {
      this.loading = true

      Object.keys(this.items).forEach((i) => this.items[i] = 0)

      this.$http.get(this.routeUri('hyperion.transaction.summary'), {params: this.filters})
        .then(res => {
          res.data.forEach(item => {
            this.items.count += parseInt(item.count)
            this.items.client_price += parseInt(item.client_price)
            this.items.biller_price += parseInt(item.biller_price)
            this.items.profit += parseInt(item.profit)
          })
        })
        .catch(err => this.handleXhrError(err))
         .finally(() => this.loading = false)
    }
  }
}
</script>

<style scoped>

</style>
